module.exports = __webpack_public_path__ + "static/media/logo_full_white.e3c8f4e6.png";